import { Route, Routes } from 'react-router-dom';
import App from '../App';
import { CompanyContextProvider } from '../context/CompanyContext';
import { RolesAccessContextProvider } from '../context/RolesAccessContext';
import GetRoles from '../features/admin/roles/GetRoles';
import checkPermissions from '../HOCs/CheckPermissions';
import AdminDashboard from '../pages/Admin/AdminDashboard';
import Dashboard from '../pages/system/Dashboard';
import ChatbotIcon from '../features/system/chat/ChatbotIcon';

const MainRoutes = () => {
  const Admin = checkPermissions({
    sectionsToAccess: [],
    Children: AdminDashboard,
  });

  return (
    <CompanyContextProvider>
      <RolesAccessContextProvider>
        <GetRoles>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/*" element={<App />} />
          </Routes>
          {['DEV', 'LOCAL'].includes(process.env['NX_APP_ENV'] ?? '') && (
            <ChatbotIcon />
          )}
        </GetRoles>
      </RolesAccessContextProvider>
    </CompanyContextProvider>
  );
};

export default MainRoutes;
